<script>
  import Heading from "../Heading.svelte";

  export let eyebrow = "";
  export let headline = "";
  export let headlineClass = "text-black active:text-black";
  export let eyebrowClass = "";
</script>

<div class="section-header text-center flex flex-col embedded-content" data-headings-increment>
  <Heading class="heading-2 order-2 {headlineClass}" text={headline} />
  {#if eyebrow}
    <div class="order-1 {eyebrowClass} pb-24 lg:pb-48">
      <span class="text-size-16 font-bold"><slot>{eyebrow}</slot></span>
    </div>
  {/if}
</div>
